import UnAuthenticatedRequest from 'services/requests/UnAuthenticated';
import apiUrlConfig from 'configs/apiUrlConfig';

const URLS = {
  SIGN_IN: `${apiUrlConfig.endPoint()}/users/sign_in`,
};

class AuthApi {
  static login(email, password) {
    return UnAuthenticatedRequest.post(URLS.SIGN_IN, {
      user: {
        email,
        password,
      },
    });
  }
}

export default AuthApi;



// WEBPACK FOOTER //
// ./src/apis/Auth.js